import { ITag } from '../data/types';
/**
 * @description concatentates test type and tags into a string
 * @param testType
 * @param tags
 * @returns
 */
export const testMetaString = (testType: string, tags: ITag[]): string => {
  if (!tags || tags.length === 0) return testType;
  return `${testType} ${tags
    .map((tag: ITag): string => {
      return tag.name;
    })
    .join(':')}`;
};
